"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VerticalSeparationInputState = void 0;
const input_state_1 = require("./input.state");
class VerticalSeparationInputState extends input_state_1.InputState {
    constructor(label) {
        super(label);
    }
    validateInput(value) {
        if (value) {
            if (!value.drawableTop || !value.drawableBottom) {
                this.setError('error');
                return;
            }
        }
        this.setError(null);
    }
}
exports.VerticalSeparationInputState = VerticalSeparationInputState;
//# sourceMappingURL=vertical.separation.input.state.js.map